import { parseUinityConfig } from '@uinity/core'

export const uinityConfig = parseUinityConfig()
